<template>
  <div class="selectgold-panel">
    <div class="mmtc_goldname">
      <img src="../assets/images/gold-text.png" />
      <span class="mmtc_goldtext">SAFEGOLD (24k 99.5 {{$t('purity')}})</span>
    </div>
    <div
      class="gold_rs"
    >₹{{this.goldConversionResult}} = {{user ? user.total_gold_amount ? user.total_gold_amount : 0 : 0}}g</div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { roundOff } from "../utils/helper";
export default {
  computed: {
    ...mapGetters(["user", "gold"])
  },
  data() {
    return {
      goldConversionResult: 0
    };
  },
  methods: {},
  mounted() {
    this.goldConversionResult = roundOff(
      (this.gold && this.gold.current_price) *
        (this.user && this.user.total_gold_amount)
    );
  }
};
</script>